<section class="hero-quick-actions" [class.has-actions]="showQuickActions">
    <div class="container">
        <h1 class="hero-title">Hola {{ userName || '' }}, <span>¿Qué necesitas?</span></h1>
        <div class="quick-actions" *ngIf="showQuickActions">
            <a class="quick-action" *ngFor="let action of actions" (click)="irA(action)">
                <span class="qa-icon">
                    <ng-container [ngSwitch]="action.iconKey">
                        <svg *ngSwitchCase="'chat'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                            <path d="M21 12c0 4.418-4.03 8-9 8-1.21 0-2.36-.213-3.41-.6L3 21l1.62-4.32C3.6 15.18 3 13.65 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" stroke-linecap="round" stroke-linejoin="round"/>
                            <line x1="8" y1="11" x2="16" y2="11" stroke-linecap="round"/>
                            <line x1="8" y1="14" x2="13" y2="14" stroke-linecap="round"/>
                        </svg>
                        <svg *ngSwitchCase="'add'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                            <rect x="3" y="3" width="18" height="18" rx="3" stroke-linejoin="round"/>
                            <line x1="12" y1="8" x2="12" y2="16" stroke-linecap="round"/>
                            <line x1="8" y1="12" x2="16" y2="12" stroke-linecap="round"/>
                        </svg>
                        <svg *ngSwitchCase="'click'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                            <rect x="3" y="3" width="18" height="18" rx="3" stroke-linejoin="round"/>
                            <path d="M10 9l5 4-2 1 1 3-1.5.7L11 14.6 9 16V9z" fill="currentColor" stroke="none"/>
                        </svg>
                        <svg *ngSwitchCase="'shield'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                            <path d="M12 3l8 3v5c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-3z" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </ng-container>
                </span>
                <h3 class="qa-title">{{ action.title }}</h3>
                <p class="qa-desc">{{ action.desc }}</p>
            </a>
        </div>
    </div>
</section>

<app-modal-dialog [show]="chatModalOpen" title="Chat con abogado" [width]="440" (closed)="closeChatModal()">

    <div class="qa-chat">
        <p class="qa-chat-question">¿Sobre qué seguro quieres consultar?</p>

        <p *ngIf="loadingProducts" class="qa-chat-loading">Cargando productos...</p>

        <div class="qa-chat-select" *ngIf="!loadingProducts">
            <select [(ngModel)]="selectedProductCode">
                <option value="" disabled>Selecciona un producto</option>
                <option *ngFor="let p of products" [value]="p.code">{{ p.name }} - {{ p.code }}</option>
            </select>
            <svg class="qa-chat-select-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </div>

    <div modal-footer class="qa-chat-actions">
        <button type="button" class="qa-chat-btn" (click)="confirmChat()" [disabled]="!selectedProductCode">
            Chatea con un abogado
        </button>
    </div>

</app-modal-dialog>
